import * as ActionTypes from '../ActionTypes';

export const GetEmployeeCanteenManagementAction = (params) => ({
  type: ActionTypes.EMPLOYEE_CANTEEN_TOKEN_GET_REQUEST,
  params,
});

export const AddEmployeeCanteenManagementAction = (params, callback) => ({
  type: ActionTypes.EMPLOYEE_CANTEEN_TOKEN_ADD_REQUEST,
  params,
  callback
});

export const UpdateEmployeeCanteenManagementAction = (params) => ({
  type: ActionTypes.EMPLOYEE_CANTEEN_TOKEN_UPDATE_REQUEST,
  params,
});

export const DeleteEmployeeCanteenManagementAction = (params) => ({
  type: ActionTypes.EMPLOYEE_CANTEEN_TOKEN_DELETE_REQUEST,
  params,
});

// Cateen Management Region Actions
export const GetCanteenRegionAction = (params) => {
    return {
        type: ActionTypes.CANTEEN_MANAGEMENT_REGION_GET_REQUEST,
        params,
    };
};

export const AddCanteenRegionAction = (params) => {
    return {
        type: ActionTypes.CANTEEN_MANAGEMENT_REGION_ADD_REQUEST,
        params,
    };
};

export const UpdateCanteenRegionAction = (params) => {
    return {
        type: ActionTypes.CANTEEN_MANAGEMENT_REGION_UPDATE_REQUEST,
        params,
    };
};

export const DeleteCanteenRegionAction = (params) => {
    return {
        type: ActionTypes.CANTEEN_MANAGEMENT_REGION_DELETE_REQUEST,
        params,
    };
};

